<template>
  <div class="modal" id="expModal" tabindex="-1" aria-labelledby="expLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">
            Explain {{ checkVar }} Trend
            <span v-show="checkVar1 != null">- ({{ checkVar1 }})</span>
          </h4>
          <div class="close-container myfaBtn" data-dismiss="modal" aria-label="Close" @click="cancel()">
            <div class="leftright"></div>
            <div class="rightleft"></div>
          </div>
        </div>
        <div class="modal-body modalChart modal-bodyHt">
          <div class="container-fluid">
            <div v-show="isExpLoad" chart-loader-spin class="settingDiv"></div>
            <div class="cardR">
              <div class="boxR" >
                <div class="row content-panel1 g-0" id="explainTsnap" style="height: 725px;" v-show="!isError">
                  <div class="insideL  hide-on-presentation ">
                    <div class="icon">
                      <font-awesome-icon icon="fa-solid fa-bars" />
                    </div>
                    <div class="contents">
                      <span>
                        <font-awesome-icon icon="fa-solid fa-chalkboard-teacher" v-on:click="addToSlider()"
                          title="Add to Storyboard" />
                        <font-awesome-icon icon="fa-solid fa-file-download" title="Download Widget"
                          v-on:click="downloadDom()" />
                      </span>
                    </div>
                  </div>
                  <div class="insideR hide-on-presentation">
                    <div class="icon">
                      <font-awesome-icon icon="fa-solid fa-info" />
                    </div>
                    <div class="contents">
                      This Chart Explains the Trends in Data. You can click on individual words/bars to get more
                      insights.<br /><br />
                      Actions you can take on this widget: <br />
                      <ul>
                        <li>Click on
                          <font-awesome-icon class="actIcon" icon="fa-solid fa-chalkboard-teacher" />
                          to add to storyboard
                        </li>
                        <li>Click on
                          <font-awesome-icon class="actIcon" icon="fa-solid fa-file-download" />
                          to download the chart with current insight
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="col-12 text-end cursor-pointer" v-on:click="drawCompChart()" v-show="showBack">
                    <a class="effect btn-back thin eff-md">
                      Go Back
                    </a>
                  </div>
                  <div class="explain-loader" v-show="!isLoadWord">
                    <widgetLoadingComp></widgetLoadingComp>
                  </div>
                  
                    <div class="chartHeightControlEx col-12" v-show="!IsIncErr && isLoadWord">
                      <div id="explainChart"></div>
                    </div>
                    <div class="col-12 mr20top">
                      <div class="panel-description">
                        <ul class="bulletList">
                          <li v-for="port in insightData" :key="port">{{ port }}</li>
                        </ul>
                      </div>
                    </div>
                
                </div>
                <div v-show="isError" class="text-center">
                  <img src="../assets/images/inquiwait1.gif" class="inquiPrImg">
                  <h3 style=" margin-top: -36px;">
                    <font-awesome-icon icon="fa-solid fa-circle-info" />
                    <span>Something Went Wrong. Please retry and if you still face issues contact the support team</span>
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
var Chart22
let selectedId = 0
let explainSource = 0
let explainType
let uriApiUrl, asgId
let self
var clrArrRed = ['#8B0000', '#B22222', '#CD5C5C', '#DC143C', '#E9967A', '#F08080', '#FA8072', '#FF0000', '#FF4500',
  '#FF6347', '#FF7F50', '#FF8C00', '#FFA07A', '#FFA500'
];
var clrArrGrn = ['#006400', '#008000', '#00FA9A', '#00FF00', '#00FF7F', '#228B22', '#2E8B57', '#3CB371', '#556B2F',
  '#7CFC00', '#90EE90', '#98FB98', '#9ACD32', '#ADFF2F'
];
var clrArrBlu = ['#000080', '#00008B', '#0000CD', '#0000FF', '#00BFFF', '#191970', '#1E90FF', '#4169E1', '#4682B4',
  '#5F9EA0', '#6495ED', '#87CEEB', '#87CEFA', '#ADD8E6', '#B0C4DE', '#B0E0E6'
];
function convert2ddhhmm(minutesValue, suffix) {
  if (suffix != "") {
    if (suffix.toUpperCase() == "H") {
      minutesValue = minutesValue * 60;
    } else if (suffix.toUpperCase() == "D") {
      minutesValue = minutesValue * 60 * 8;
    }
    var hours = Math.floor(minutesValue / 60);
    var minutes = Math.round((minutesValue % 60), 2);
    var days = 0;
    if (hours > 24) {
      days = Math.floor(hours / 24);
      hours = Math.floor(hours % 24);
    }
    var returnVal = '';
    if (days != 0) {
      returnVal += days + 'd ';
    }
    if (hours != 0) {
      returnVal += hours + 'h ';
    }
    if (minutes != 0) {
      returnVal += minutes + 'm ';
    }
  } else {
    returnVal = minutesValue;
  }
  if (returnVal == 0) {
    returnVal = '-'
  }
  return returnVal;
}
import {
  Modal
} from "bootstrap";
import domtoimage from "dom-to-image-more";
import {
  useRoute
} from "vue-router";
import * as echarts from 'echarts';
import screenShotMix from "./../mixin/screenShotMix";
import widgetLoadingComp from './../components/smallcomp/widgetloader.vue';
var myChart;
var chartDom;
function reportWindowSizeDT() {
  if (myChart != undefined) {
    chartDom.style.width = (document.getElementById('explainTsnap').clientWidth - 50) + "px";
    myChart.resize();
  }
}
export default {
  name: "ExplainModal",
  mixins: [screenShotMix],
  props: {
    viewName: String,
  },
  components: {
    widgetLoadingComp,
  },
  data() {
    return {
      modal: undefined,
      TClrs: "",
      checkVar: "",
      checkVar1: "",
      isInc: false,
      isExpLoad: false,
      isDec: false,
      isStbl: false,
      isDeleteModal: true,
      Deleteloader: false,
      headername: "",
      showDec: true,
      showSta: true,
      showInc: true,
      myDesColr: "",
      myIncColr: "",
      showBack: false,
      IsIncErr: "",
      insightData: [],
      datasets: undefined,
      isLoadWord: true,
      isError: false,
    };
  },
  methods: {
    showExpModal(hdr) {
      explainType = hdr.currpass
      explainSource = hdr.Cond
      selectedId = hdr.selid
      self = this
      uriApiUrl = this.uriApiUrl
      asgId = this.asgId
      this.datasets = undefined
      this.drawCompChart();
      this.modal.show();
    },
    cancel() {
      this.insightData = [];
      if (Chart22 != undefined) {
        Chart22.destroy()
      }
      this.modal.hide();
    },
    actualDraw(parm1, parm2, parm3, isClick) {
      if (!isClick) {
        this.showBack = true;
      } else {
        this.showBack = false;
      }
      let countR = 0,
        countG = 0,
        countB = 0;
      try {
        let seriesArr = [];
        let isInc = false, isDec = false, isNoTrend = false;
        for (let index = 0; index < parm1.length - 1; index++) {
          let element = parm1[index];
          if (element.trendpattern == 'decreasing') {
            seriesArr.push({
              name: element.label,
              dataGroupId: 'S1',
              type: 'line',
              animationDuration: 1500,
              universalTransition: true,
              xAxisIndex: 3,
              yAxisIndex: 3,
              data: element.data
            })
            isDec = true;
            element.borderColor = clrArrRed[countR];
            element.backgroundColor = clrArrRed[countR];
            countR++;
          } else if (element.trendpattern == 'increasing') {
            seriesArr.push({
              name: element.label,
              dataGroupId: 'S2',
              type: 'line',
              animationDuration: 1500,
              universalTransition: true,
              xAxisIndex: 2,
              yAxisIndex: 2,
              selectedMode: false,
              data: element.data
            })
            isInc = true;
            element.borderColor = clrArrGrn[countG];
            element.backgroundColor = clrArrGrn[countG];
            countG++;
          } else {
            seriesArr.push({
              name: element.label,
              dataGroupId: 'S3',
              type: 'line',
              animationDuration: 1500,
              universalTransition: true,
              xAxisIndex: 1,
              yAxisIndex: 1,
              data: element.data
            })
            isNoTrend = true;
            element.borderColor = clrArrBlu[countB];
            element.backgroundColor = clrArrBlu[countB];
            countB++;
          }
        }
        seriesArr.push({
          name: 'Overall',
          type: 'line',
          animationDuration: 1500,
          universalTransition: true,
          dataGroupId: 'S0',
          xAxisIndex: 0,
          yAxisIndex: 0,
          data: parm1[parm1.length - 1].data
        })
        chartDom = document.getElementById('explainChart');
        if(chartDom == null){
          return
        }
        chartDom.style.height = "500px";
        chartDom.style.width = (document.getElementById('explainTsnap').clientWidth - 50) + "px";
        myChart = echarts.init(chartDom);
        var option;
        option = {
          toolbox: {
            right: 20,
            top: 40,
            itemSize: 20,
            iconStyle: {
              borderColor: '#777'
            },
            feature: {
              magicType: {
                type: ['bar', 'line']
              }
            }
          },
          legend: [{
            top: 0,
            orient: 'horizontal',
            type: 'scroll',
            textStyle: {
              fontSize: 10,
              color: "#777"
            },
          }],
          grid: [{
            left: '7%',
            top: '10%',
            width: '35%',
            height: '35%'
          },
          {
            right: '10%',
            top: '10%',
            width: '35%',
            height: '35%'
          },
          {
            left: '7%',
            bottom: '5%',
            width: '35%',
            height: '40%'
          },
          {
            right: '10%',
            bottom: '5%',
            width: '35%',
            height: '40%'
          }
          ],
          title: [{
            text: 'Overall',
            top: '6%',
            left: '20%',
            textAlign: 'center',
            textStyle: {
              color: "#777"
            }
          },
          {
            text: 'No Particular Trend',
            show: isNoTrend,
            top: '6%',
            left: '68%',
            textAlign: 'center',
            textStyle: {
              color: "#777"
            }
          },
          {
            text: 'Increasing Trend',
            show: isInc,
            left: '20%',
            top: '49%',
            textAlign: 'center',
            textStyle: {
              color: "#777"
            }
          },
          {
            text: 'Decreasing Trend',
            show: isDec,
            left: '68%',
            top: '49%',
            textAlign: 'center',
            textStyle: {
              color: "#777"
            }
          }
          ],
          tooltip: {
            trigger: 'axis',
            confine: true,
            valueFormatter: function (value) {
              if (explainType.includes("Rate") || explainType.includes("%")) {
                return value + "%";
              } else if (explainType.includes("MTTR") || explainType.includes("MTTA")) {
                return convert2ddhhmm(value, "M")
              } else {
                return value;
              }
            }
          },
          xAxis: [{
            gridIndex: 0,
            type: 'category',
            data: parm2
          },
          {
            gridIndex: 1,
            show: isNoTrend,
            type: 'category',
            data: parm2
          },
          {
            gridIndex: 2,
            show: isInc,
            type: 'category',
            data: parm2
          },
          {
            gridIndex: 3,
            show: isDec,
            type: 'category',
            data: parm2
          }
          ],
          yAxis: [{
            gridIndex: 0,
            scale: true,
            axisLabel: {
              formatter: function (value, index) {
                if (explainType.includes("Rate") || explainType.includes("%")) {
                  return value + "%";
                } else if (explainType.includes("MTTR") || explainType.includes("MTTA")) {
                  return convert2ddhhmm(value, "M")
                } else {
                  return value;
                }
              },
                fontSize: 10,
                color: "#777"
            },
            splitArea: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisLine: {
              show: true
            },
          },
          {
            gridIndex: 1,
            show: isNoTrend,
            scale: true,
            axisLabel: {
              formatter: function (value, index) {
                if (explainType.includes("Rate") || explainType.includes("%")) {
                  return value + "%";
                } else if (explainType.includes("MTTR") || explainType.includes("MTTA")) {
                  return convert2ddhhmm(value, "M")
                } else {
                  return value;
                }
              },
              fontSize: 10,
              color: "#777"
            },
            splitArea: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisLine: {
              show: true
            },
          },
          {
            gridIndex: 2,
            show: isInc,
            scale: true,
            axisLabel: {
              formatter: function (value, index) {
                if (explainType.includes("Rate") || explainType.includes("%")) {
                  return value + "%";
                } else if (explainType.includes("MTTR") || explainType.includes("MTTA")) {
                  return convert2ddhhmm(value, "M")
                } else {
                  return value;
                }
              },
              fontSize: 10,
              color: "#777"
            },
            splitArea: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisLine: {
              show: true
            },
          },
          {
            gridIndex: 3,
            show: isDec,
            scale: true,
            axisLabel: {
              formatter: function (value, index) {
                if (explainType.includes("Rate") || explainType.includes("%")) {
                  return value + "%";
                } else if (explainType.includes("MTTR") || explainType.includes("MTTA")) {
                  return convert2ddhhmm(value, "M")
                } else {
                  return value;
                }
              },
                fontSize: 10,
                color: "#777"
            },
            splitArea: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisLine: {
              show: true
            },
          }
          ],
          series: seriesArr
        };
        option && myChart.setOption(option);
      } catch (error) {
        // console.log(error)
      }
    },
    hideShowTrends() {
      const self = this;
      Chart22.data.datasets.forEach(function (ds) {
        if (ds.label != "Overall") {
          if (ds.trendpattern == 'increasing') {
            if (self.isInc) {
              ds.hidden = false;
            } else {
              ds.hidden = true;
            }
          } else if (ds.trendpattern == 'decreasing') {
            if (self.isDec) {
              ds.hidden = false;
            } else {
              ds.hidden = true;
            }
          } else {
            if (self.isStbl) {
              ds.hidden = false;
            } else {
              ds.hidden = true;
            }
          }
        }
      });
      Chart22.update();
    },
    downloadDom() {
      var widgetID = "explainTsnap";
      var imgname = "Explain_Trend.png";
      var geticondiv = document.querySelectorAll('#explainTsnap .insideL,#explainTsnap .insideR')
      geticondiv.forEach(box => {
        box.style.opacity = 0;
      });
      document.getElementById(widgetID).classList.remove("myZoomClass")
      domtoimage.toBlob(document.getElementById(widgetID))
        .then(function (blob) {
          window.saveAs(blob, imgname);
          geticondiv = document.querySelectorAll('#explainTsnap .insideL,#explainTsnap .insideR')
          geticondiv.forEach(box => {
            box.style.opacity = 1;
          });
          document.getElementById(widgetID).classList.add("myZoomClass")
        });
    },
    addToSlider() {
      let insArr = this.insightData;
      let second = "";
      if (this.checkVar1 != null) {
        second = this.checkVar1;
      }
      let name = this.checkVar + " Trend " + second + " - " + this.viewName;
      let screenShort = {
        id: 'explainTsnap',
        name: 'Explain.png'
      }
      this.addToSliderMix(screenShort, insArr, name)
    },
    drawCompChart() {
      let tempArr = explainType.split("~");
      this.checkVar = tempArr[0];
      this.isLoadWord = false;
      this.isError = false;
      if (tempArr.length > 0) {
        this.checkVar1 = tempArr[1];
      }
      if (this.datasets == undefined) {
        this.isExpLoad = true;
        let sendata = {
          "selid": selectedId,
          "Type": explainType,
          "cond": explainSource,
          "doubleclick": "",
        }
        this.axios.post(uriApiUrl + "DataAnalysis/keydrilldown?asg_id=" + asgId, sendata,{
      headers: {
            'Content-Type': 'application/json'
          }})
          .then((response) => {
            if (response.data != "Error") {
              if (Chart22 != undefined) {
                Chart22.destroy()
              }
              this.datasets = response.data.chart;
              this.parent = response.data.chart;
              if (['Backlog'].includes(this.checkVar)) {
                for (let index = 0; index < this.datasets.length; index++) {
                  const element = this.datasets[index];
                  element.data.splice(0, 1)
                }
                response.data.moncnt.splice(0, 1)
                response.data.labels.splice(0, 1)
              }
              this.datasets.push({
                "sidedata": response.data.moncnt,
                type: 'line',
                yAxisID: "y-axis-1",
                "label": "Overall",
                backgroundColor: "#FFA700",
                "borderColor": "#FFA700",
                "hidden": false,
                "data": response.data.moncnt,
                "trendpattern": ""
              })
              this.labels = response.data.labels;
              this.insightData = response.data.insights;
              this.insightDataS = response.data.insights;
              this.topvalues = [];
              for (let index = 0; index < response.data.topvalues.length; index++) {
                const element = response.data.topvalues[index];
                if (element.trend != "stable") {
                  this.topvalues.push(element.Name);
                }
              }
              this.actualDraw(this.datasets, this.labels, this.topvalues, true);
              this.isLoadWord = true;
            } else {
              this.$notify({
                type: "error",
                text: 'Sorry! Something went wrong. Try after sometime!'
              })
              this.isLoadWord = true;
              this.isError = true
            }
            this.isExpLoad = false;
            this.isLoadWord = true;
          }).catch((error) => {
            this.$notify({
              type: "error",
              text: "Sorry! Something went Wrong! Try after sometime!"
            })
            this.isLoadWord = true;
          });
      } else {
        this.insightData = this.insightDataS;
        if (Chart22 != undefined) {
          Chart22.destroy()
        }
        this.actualDraw(this.datasets, this.labels, this.topvalues, true);
        this.isLoadWord = true;
      }
    },
  },
  mounted() {
    this.modal = new Modal(document.getElementById("expModal"));
    const route = useRoute()
    this.asgId = route.params.asgid;
    window.addEventListener("resize", reportWindowSizeDT);
  },
  unmounted() {
    window.removeEventListener("resize", reportWindowSizeDT);
  },
};
</script>
<style scoped>
.bulletList {
  font-size: 0.9rem;
}
.darkTheme .modal-content {
  color: #dddddd !important;
}
</style>